/**
 * Password reset links from the reset email look like
 *   https://careweave.ca/#reset?email=...&code=...
 * The details sit after "#", so browsers never send them to the server and
 * they stay out of server logs. The link only fills in the reset form; the
 * server still checks the code against that email.
 */

export interface ResetLink {
  email: string;
  code: string;
}

export function readResetLink(): ResetLink | null {
  try {
    const hash = window.location.hash;
    if (!hash.startsWith('#reset?')) return null;
    const params = new URLSearchParams(hash.slice('#reset?'.length));
    const email = params.get('email')?.trim() ?? '';
    const code = params.get('code')?.trim() ?? '';
    return email && code ? { email, code } : null;
  } catch {
    return null;
  }
}

/** Remove the code from the address bar and history once it has been read. */
export function clearResetLink(): void {
  try {
    if (window.location.hash.startsWith('#reset')) {
      window.history.replaceState(null, '', window.location.pathname + window.location.search);
    }
  } catch { /* history API may be unavailable */ }
}
